import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { isBetaResolver } from './core/resolvers/is-beta.resolver';

const routes: Routes = [
  { path: '', redirectTo: 'flow', pathMatch: 'full' },
  {
    path: 'flow',
    loadChildren: () =>
      import('./luqas-configuration/luqas-configuration.module').then(
        (m) => m.LuqasConfigurationModule,
      ),
    resolve: { isBeta: isBetaResolver },
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./page-not-found/page-not-found.module').then(
        (m) => m.PageNotFoundModule,
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
